import CarIcon from "../res/icons/Car.svg";
import CloudIcon from "../res/icons/Cloud.svg";
import DashboardIcon from "../res/icons/Dashboard.svg";
import DocumentIcon from "../res/icons/Document.svg";
import EnergyIcon from "../res/icons/Energy.svg";
import GraphIcon from "../res/icons/Graph.svg";
import PaymentIcon from "../res/icons/Payment.svg";
import SettingsIcon from "../res/icons/Settings.svg";
import SolarPanelIcon from "../res/icons/SolarPanel.svg";
import SpinnerIcon from "../res/icons/spinner-solid.svg";
import StatementIcon from "../res/icons/Statement.svg";
import TrolleyIcon from "../res/icons/Trolley.svg";

export const SolarCloudIcon = {
  Allocations: <PaymentIcon />,
  Car: <CarIcon />,
  Cloud: <CloudIcon />,
  Contact: <DocumentIcon />,
  Dashboard: <DashboardIcon />,
  Document: <DocumentIcon />,
  Energy: <EnergyIcon />,
  Graph: <GraphIcon />,
  Invoices: <DocumentIcon />,
  Location: <EnergyIcon />,
  Logout: <SettingsIcon />,
  Orders: <DocumentIcon />,
  Password: <SettingsIcon />,
  Payment: <PaymentIcon />,
  Settings: <SettingsIcon />,
  SolarPanel: <SolarPanelIcon />,
  Spinner: <SpinnerIcon />,
  Statement: <StatementIcon />,
  TermsAndConditions: <DocumentIcon />,
  Tracker: <DocumentIcon />,
  Trolley: <TrolleyIcon />,
};

export type SolarCloudIconType = React.ReactElement;
